import { Box, Button, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../theme";
import pic from "../image/top_image1.svg";


export const Top = ({setPage}) => {
    return(
        <ThemeProvider theme={theme}>
            <Box 
              sx={{ 
                display: "flex",
                flexDirection: {mobile: "column", pc: "row"},
                mt: {mobile: 2, pc: 4},
              }}
            >
                
                <Box sx={{ display: {mobile: "none", pc: "block"}, flex: 1 }}>
                    <Box 
                      component="img" 
                      sx={{ 
                        mt: 10, 
                        width: "100%",
                      }} 
                      src={pic}
                    />
                </Box>

                <Box sx={{ flex: 1, textAlign: "center" }}>
                    <Typography
                      sx={{
                        mt: 1.5,
                        px: 2,
                        width: "fit-content",
                        fontSize: {mobile: 32, pc: 46},
                        lineHeight: 1.2,
                        fontWeight: "bold",
                        color: "text.paper",
                        bgcolor: "background.black",
                      }}
                    >
                        PlayGround
                    </Typography>
                    <Typography
                      sx={{
                        mt: 1.5,
                        px: 2,
                        textAlign: "left",
                        width: "fit-content",
                        fontSize: {mobile: 32, pc: 46},
                        lineHeight: 1.2,
                        fontWeight: "bold",
                        color: "text.paper",
                        bgcolor: "background.black",
                      }}
                    >
                        Course Adviser
                    </Typography>
                    <Box 
                      component="img" 
                      sx={{ 
                        display: {moble: "block", pc: "none"},
                        mt: 3,
                        width: "100%",
                    }} 
                      src={pic}
                    />
                    <Typography
                      sx={{
                        mt: {mobile: 3, pc: 8},
                        px: 3,
                        textAlign: "left",
                        fontSize: {mobile: 15, pc: 22},
                        lineHeight: 1.7,
                        color: "text.primary",
                      }}
                    >
                        簡単な10の質問からあなたの適正コースを診断します。
                        WILLが提供する次世代のコース診断アプリで新たな扉を開きましょう！
                    </Typography>
                    <Button
                      variant="outlined"
                      fullWidth="true"
                      sx={{
                        mt: {mobile: 3, pc: 8},
                        maxWidth: 273,
                        height: {pc: 56},
                        fontWeight: "bold",
                        fontSize: {pc: 18},
                      }}
                      onClick={() => {setPage("questions")}}
                    >
                        診断開始
                    </Button>
                </Box>
            </Box>
        </ThemeProvider>
    )
};
